<!-- eslint-disable -->
<template>
  <div :class="'formgroup'">
    <div :class="'address-head'" :id="text + 'AddressHead'">
      <h3 :class="'h3'"><span v-if="editing">Editing </span><span v-if="editing">{{text}}</span><span v-if="!editing">{{capitalise(text)}}</span> address</h3>
      <span class="form-error address hidden js-form-error js-address-error" :id="text + 'AddressError'" :data-validation-message="'Please provide your ' + text + ' address'" aria-live="assertive"></span>
      <p
      id="prevaddress"
      class="note"
      v-if="text == 'previous' && !chosenopt"
      aria-live="assertive"
    >Since you have lived at your current address less than two years, we need your previous address to complete your address history</p>
      <p v-if="!chosenopt" class="note">Enter the postcode for your address and a house/flat number or name</p>
    </div>
    <div v-if="card && chosenopt && !editing" :class="'address-card'">
      <div class="address-card-upper">
        <div>
          <span class="address-in-card" :id="text + 'AddFull'" v-html="formattedChosenOpt"></span>
          <span :id="text + 'AddTop'" hidden="true">{{namePostcode}}</span>
        </div>
        <button @click.prevent="edit()">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <g clip-path="url(#clip0_403_1362)">
            <path d="M3 17.2501V21.0001H6.75L17.81 9.94006L14.06 6.19006L3 17.2501ZM20.71 7.04006C21.1 6.65006 21.1 6.02006 20.71 5.63006L18.37 3.29006C17.98 2.90006 17.35 2.90006 16.96 3.29006L15.13 5.12006L18.88 8.87006L20.71 7.04006Z" fill="black"/>
            </g>
            <defs>
            <clipPath id="clip0_403_1362">
            <rect width="24" height="24" fill="white"/>
            </clipPath>
            </defs>
          </svg>
          <span>Edit</span>
        </button>
      </div> 
      <!-- 0 years 0 months -->
      <p v-if="times[0] != null && times[1] != null && times[0] == 0 && times[1] == 0"><strong>Less than a month</strong> at this address</p>
      <!-- 0 years 1 month -->
      <p v-if="times[0] != null && times[1] != null && times[0] == 0 && times[1] == 1"><strong>{{ times[1] }} month</strong> at this address</p>
      <!-- 0 years x months -->
      <p v-if="times[0] != null && times[1] != null && times[0] == 0 && times[1] > 1"><strong>{{ times[1] }} months</strong> at this address</p>

      <!-- 1 year 0 months -->
      <p v-if="times[0] != null && times[1] != null && times[0] == 1 && times[1] == 0"><strong>{{ times[0] }} year</strong> at this address</p>
      <!-- 1 year 1 month -->
      <p v-if="times[0] != null && times[1] != null && times[0] == 1 && times[1] == 1"><strong>{{ times[0] }} year and {{ times[1] }} month</strong> at this address</p>
      <!-- 1 year x months -->
      <p v-if="times[0] != null && times[1] != null && times[0] == 1 && times[1] > 1"><strong>{{ times[0] }} year and {{ times[1] }} months</strong> at this address</p>

      <!-- x years null months -->
      <p v-if="times[0] != null && times[1] == null && times[0] > 1"><strong>{{ times[0] }} years</strong> at this address</p>
      <!-- x years 0 months -->
      <p v-if="times[0] != null && times[1] != null && times[0] > 1 && times[1] == 0"><strong>{{ times[0] }} years</strong> at this address</p>
      <!-- x years 1 month -->
      <p v-if="times[0] != null && times[1] != null && times[0] > 1 && times[1] == 1"><strong>{{ times[0] }} years and {{ times[1] }} month</strong> at this address</p>
      <!-- x year x months -->
      <p v-if="times[0] != null && times[1] != null && times[0] > 1 && times[1] > 1"><strong>{{ times[0] }} years and {{ times[1] }} months</strong> at this address</p>
    </div>
    <span
      class="addressinv form-error js-form-error"
      v-if="invalidsame && !card && !manual"
      id="errorSame"
      aria-live="assertive"
    >Previous address can't be the same as your current address</span>
    <div :class="'address-lookup' + ' ' + text" v-if="!chosenopt">
      <!-- postcode (for lookup) -->
      <input-group
        v-bind:key="obj[1][1]"
        :id="obj[1][1]"
        :text="obj[1][0]"
        :externalErrors="errors"
        :opt="{class: 'addinps', autocomplete: 'postal-code', type: 'text'}"
        ></input-group>
      <!-- house name or number (for lookup) -->
      <input-group
        v-bind:key="obj[0][1]"
        :id="obj[0][1]"
        :text="obj[0][0]"
        :externalErrors="errors"
        :opt="{class: 'addinps', autocomplete: 'no', type: 'text'}"
        ></input-group>
      <!-- buttons for find address or entering manually -->
      <div class="address-buttons-wrap">
        <button
        id="findAddressBtn"
        type="button"
        @click="validateAddress([obj[0], obj[obj.length - 1]], []) ? (searchAddress(), editing = false, manual = false) : ''"
        >Find address</button>
        <p v-if="!manual" :class="'no-remove'"><span class="or">or </span>
        <a
          href="#"
          role="button"
          id="manualEnterAdd"
          @click.prevent="manual = true, addready = true, chooseopt = false, headFocusCustom('manualAddressHead', true)"
          v-if="!manual"
        >Enter your address manually</a>
        </p>
      </div>
      <!-- manual address entry-->
      <div v-if="manual && !chooseopt" :class="'formgroup manual-address-entry'">
        <div :class="'address-head'" id="manualAddressHead">
          <h3 :class="'h3'"">Enter your address manually</h3>
          <p class="no-remove note">Enter all the information that applies to your address. Leave fields empty if they're not applicable</p>
          <div :class="errors['errorSummary'] ? 'form-error-summary js-form-error' : 'form-error-large address-entry hidden js-form-error'" aria-live="assertive">
            <p class="form-error-summary__heading">To add an address manually, you must include:</p>
            <ul>
              <li>Flat number, house name OR house number</li>
              <li v-for="(item) in this.addressFieldValidations" v-if="!item.optional">{{!item.optional ? toSentenceCase(item.name) : null  }}</li>
              <li>Postcode</li>
            </ul>
          </div>
          <span :class="errors['noneOfThree'] ? 'form-error addressinv js-form-error' : 'form-error addressinv hidden js-form-error'" aria-live="assertive">{{ errors['noneOfThree'] }}</span>
        </div>
        <span
          class="addressinv form-error js-form-error"
          id="errorSame"
          v-if="invalidsame && !card"
          aria-live="assertive"
        >Previous address can't be the same as your current address</span>
        <!-- manual address fields-->
        <input-group
          v-for="(inps, index) in objManual"
          v-bind:key="inps[1]"
          :addressValue="text == 'current' ? inps[3] : inps[4]"
          :id="inps[1]"
          :text="inps[0]"
          :externalErrors="errors"
          :externalTouched="touchedFields[inps[1]] || false"
          :addressFieldValidations="addressFieldValidations"
          :opt="{class: 'addinps', autocomplete: index === 4 ? 'address-level3' : index === 5 ? 'address-level2' : index === 6 ? 'address-level1' : index === 7 ? 'postal-code' : 'no', type: 'text' }">
        </input-group>
      </div>
      <!-- end manual address entry-->
    </div>
    <div v-if="editing || (chooseopt && !manual && !editing)" :class="'address-lookup' + ' ' + text + ' editing-address-entry'">
      <div :class="errors['errorSummary'] ? 'form-error-summary address-entry js-form-error' : 'form-error-large address-entry hidden js-form-error'" aria-live="assertive">
        <p class="form-error-summary__heading">To add an address manually, you must include:</p>
        <ul>
          <li>Flat number, house name OR house number</li>
          <li v-for="(item) in this.addressFieldValidations" v-if="!item.optional">{{!item.optional ? toSentenceCase(item.name) : null  }}</li>
          <li>Postcode</li>
        </ul>
      </div>
      <span :class="errors['noneOfThree'] ? 'form-error addressinv js-form-error' : 'form-error addressinv hidden js-form-error'" aria-live="assertive">{{ errors['noneOfThree'] }}</span>
      <!-- manual address fields when editing -->
      <input-group
        v-if="editing" v-for="(inps, index) in objManual"
        v-bind:key="inps[1]"
        :addressValue="text == 'current' ? inps[3] : inps[4]"
        :id="inps[1]"
        :text="inps[0]"
        :externalErrors="errors"
        :externalTouched="touchedFields[inps[1]] || false"
        :addressFieldValidations="addressFieldValidations"
        :opt="{class: 'addinps', autocomplete: index === 4 ? 'address-level3' : index === 5 ? 'address-level2' : index === 6 ? 'address-level1' : index === 7 ? 'postal-code' : 'no', type: 'text' }">
      </input-group>
      <!-- select address from lookup-->
      <div :class="'select-address vertical'" v-if="chooseopt && !manual && !editing">
        <p role="status" id="selectAddressList">Select an address</p>
        <ul class="select-address-list">
          <li class="select-address-item horizontal" v-bind:key="text[0]" v-for="text, ind in selectopts">
            <a
              @keypress.enter.prevent="$event.target.click"
              href="#"
              tabindex="0"
              role="button"
              :id="'selectAddress' + ind"
              class="select-address-link"
              @click.prevent="notExact(text[1]) ? (formatAdd(text[0]), chosenopt = text[1], chooseopt = false, addready = true) : (selectopen = false)">
              {{ text[1] }}
            </a>
          </li>
        </ul>
      </div>
    <!-- end select address -->
    </div>
    <div :class="'formgroup'" v-if="addready || editing || (!timeAndAddressAdded && chooseopt)">
      <div class="formgroup">
        <a href="#" role="button" v-if="editing" @click.prevent="reset()">Find a different address</a>
      </div>
      <fieldset class="formgroup" v-if="editing || !time[0]">
        <legend v-if="text != 'previous'">How long have you been at this address for?</legend>
        <legend v-if="text == 'previous'">How long were you at this address for?</legend>
        <span :class="errors['timey'] ? 'form-error select js-form-error' : 'form-error select hidden js-form-error'" aria-live="assertive">{{ errors['timey'] }}</span>
        <numb-choose
        :value.sync="times[0]"
        :yearsValue="times[0]"
        :isPrevious="text == 'previous'"
        :timeAndAddressAdded="timeAndAddressAdded"
        :id="time[0][0]"
        :text="time[0][1]"
        :key="time[0][0]"
        :editing="editing"
        @update:value="handleYearChange"
        @reset-months="resetMonths"
      ></numb-choose>
      <span :class="errors['timem'] ? 'form-error select addressinv js-form-error' : 'form-error select hidden js-form-error'" aria-live="assertive">{{ errors['timem'] }}</span>
      <numb-choose
        v-if="showMonthsDropdown"
        :value.sync="times[1]"
        :yearsValue="times[0]"
        :isPrevious="text == 'previous'"
        :timeAndAddressAdded="timeAndAddressAdded"
        :id="time[1][0]"
        :text="time[1][1]"
        :key="time[1][0]"
        :editing="editing"
        @update:value="handleMonthChange"
      ></numb-choose>
      </fieldset>
      <aside v-if="editing && !addDateMovedIn && text !== 'previous'" class="aside">
        <span>Not sure how long you've been at this address?</span>
        <a href="#" role="button" @click.prevent="addDateMovedIn = true, headFocusCustom('dateMovedIn')">Enter when you moved in</a>
      </aside>
      <fieldset v-if="addDateMovedIn && editing" id="dateMovedIn" class="formgroup">
        <legend>When did you move into this address?</legend>
        <div class="inputs-wrap">
          <span class="datetext">For example 12 / 2000</span>
          <span :class="errors['dateMovedIn'] ? 'form-error js-form-error' : 'form-error hidden js-form-error'" aria-live="assertive"">{{ errors['dateMovedIn'] }}</span>
          <div class="dateitems">
            <input-group
              v-for="(date, index) in dateInputs"
                v-bind:key="date"
                :id="text + 'MovedIn' + date"
                :text="date"
                :opt="{placeholder: null, class: index == 1 ? 'dateinps year' : 'dateinps', autocomplete: 'off', type: 'number'}"> 
            </input-group>
          </div>
          <div class="address-buttons-wrap">
            <button type="button" @click.prevent="dateMovedIn()">Add this date</button>
          </div>
        </div>
      </fieldset>
      <div class="address-buttons-wrap save-cancel" v-if="editing">
        <button @click="validateAddress(objManual, formatted, manual, time) ? (addAddress(objManual, time, manual, chosenopt, text), editing = false, addready = false, addednow = true, manual = false, showAddressDurationError = false) : ''" type="button">
          <span>Save changes</span>
        </button>
        <button :class="'cancel'" :id="'btnCancel'" @click="cancel()" type="button">
          <span>Cancel</span>
        </button>
      </div>
      <fieldset v-if="chosenopt && !editing && !manual && !timeAndAddressAdded">
        <legend v-if="text != 'previous'">How long have you been at this address for?</legend>
        <legend v-if="text == 'previous'">How long were you at this address for?</legend>
        <span :class="errors['timey'] ? 'form-error select js-form-error' : 'form-error select hidden js-form-error'" aria-live="assertive"">{{ errors['timey'] }}</span>
        <numb-choose
        :value.sync="times[0]"
        :yearsValue="times[0]"
        :isPrevious="text == 'previous'"
        :timeAndAddressAdded="timeAndAddressAdded"
        :id="time[0][0]"
        :text="time[0][1]"
        :key="time[0][0]"
        :editing="editing"
        @update:value="handleYearChange"
        @reset-months="resetMonths"
      ></numb-choose>
      <span :class="errors['timem'] ? 'form-error select js-form-error' : 'form-error select hidden js-form-error'" aria-live="assertive"">{{ errors['timem'] }}</span>
      <numb-choose
        v-if="showMonthsDropdown"
        :value.sync="times[1]"
        :yearsValue="times[0]"
        :isPrevious="text == 'previous'"
        :timeAndAddressAdded="timeAndAddressAdded"
        :id="time[1][0]"
        :text="time[1][1]"
        :key="time[1][0]"
        :editing="editing"
        @update:value="handleMonthChange"
      ></numb-choose>
      </fieldset>
      <aside v-if="(!editing && !addDateMovedIn && !addednow && chosenopt && text !== 'previous') && text == 'current'" class="aside">
        <span>Not sure how long you've been at this address?</span>
        <a href="#" role="button" @click.prevent="addDateMovedIn = true, headFocusCustom('dateMovedIn')">Enter when you moved in</a>
      </aside>
      <fieldset v-if="addDateMovedIn && !addednow && !editing" id="dateMovedIn" class="formgroup">
        <legend>When did you move into this address?</legend>
        <div class="inputs-wrap">
          <span class="datetext">For example 12 / 2000</span>
          <span :class="errors['dateMovedIn'] ? 'form-error js-form-error' : 'hidden js-form-error'" aria-live="assertive"">{{ errors['dateMovedIn'] }}</span>
          <div class="dateitems">
            <input-group
              v-for="(date, index) in dateInputs"
                v-bind:key="date"
                :id="text + 'MovedIn' + date"
                :text="date"
                :opt="{placeholder: null, class: index == 1 ? 'dateinps year' : 'dateinps', autocomplete: 'off', type: 'number'}"> 
            </input-group>
          </div>
          <div class="address-buttons-wrap">
            <button type="button" @click.prevent="dateMovedIn()">Add this date</button>
          </div>
        </div>
      </fieldset>
      <button :id="'btnAddAddress'" :class="'btn-add-address'" v-if="manual && !editing && !chosenopt" @click="validateAddress(objManual, formatted, manual, false) ? (addAddress(objManual, false, manual, chosenopt, text), addready = true, manual = false, showAddressDurationError = false) : ''" type="button">
        <span>Add this address</span>
      </button>
      <aside v-if="chooseopt" class="aside">
        <span>Can't see the address?</span>
        <a href="#" role="button" @click.prevent="manual = true, addready = true, chooseopt = false, headFocusCustom('manualAddressHead', true)">Enter the address manually</a>
      </aside>
    </div>
  </div>
</template>

<script>

/*eslint-disable */
import inputGroup from './inputGroup.vue'
import numbChoose from './numbChoose.vue'

export default {
    name: 'addressSearch',
    data: function() {
        return {
            manual: false,
            namePostcode: [],
            finding: false,
            invalidadd: false,
            invalidsame: false,
            showAddressDurationError: false,
            card: false,
            selectopen: false,
            selectopts: [],
            experurl: process.env.VUE_APP_ADDRESS_URL,
            experkey: process.env.VUE_APP_ADDRESS_KEY,
            chooseopt: false,
            chosenopt: false,
            showAddAddressBtn: true,
            previousTimes: [],
            formatted: [],
            selectedAddress: {},
            addready: false,
            addednow: false,
            time: [
                ["timey", "Years", 120],
                ["timem", "Months", 11]
            ],
            times: [
                null, null
            ],
            initialTimes: [
                null, null
            ],
            skipWatcher: false,
            showMonthsDropdown: false,
            savedAddress: {},
            editing: false,
            timeAndAddressAdded: false,
            addDateMovedIn: false,
            dateInputs: ["Month", "Year"],
            errors: {},
            touchedFields: {},
            addressFieldValidations: {
              houseNameManual: { min: 1, max: 32, optional: true, name: 'house name' },
              houseNumber: { min: 1, max: 32, optional: true, name: 'house number' },
              flatNumber: { min: 1, max: 32, optional: true, name: 'flat number' },
              streetName: { min: 1, max: 40, optional: true, name: 'street name' },
              localityName: { min: 1, max: 32, optional: true, name: 'address line 2' },
              townName: { min: 1, max: 32, optional: false, name: 'town/city' },
              countyName: { min: 1, max: 32, optional: true, name: 'county'},
            },
        }
    },
    components: {
        inputGroup,
        numbChoose
    },
    props: {
        obj: Array,
        objManual: Array,
        text: String
    },
    computed: {
      formattedChosenOpt() {
        return this.chosenopt ? this.chosenopt.replace(/,/g, ',<br>') : '';
      }
    },
    methods: {
    handleYearChange(value) {
      if (value) {
        this.$delete(this.errors, 'timey');
      }
      if (value == 0 || value == 1) {
        this.showMonthsDropdown = true;
        this.headFocusCustom('timem');
      } else {
        this.showMonthsDropdown = false;
        this.$delete(this.errors, "timem");
        this.times[1] = null; // Reset months if years value changes
      }
    },
    handleMonthChange(value) {
      if (value) {
        this.$delete(this.errors, 'timem');
      }
    },
    capitalise: function(a) {
      return a.charAt(0).toUpperCase() + a.slice(1);
    },
    toSentenceCase: function(a) {
      var b = a.toLowerCase();
      return this.capitalise(b);
    },
    searchAddress: function() {
      var postcodeToValidate = document.getElementById("postCodeAuto").value.trim().replace(/\s/g, "");
      var excludedPostCodeRegex = new RegExp('(GY|IM|JE)[0-9]{1,2}[ ]?[0-9]([a-zA-Z]{1,2})', 'i');
      if (excludedPostCodeRegex.test(postcodeToValidate)) {
        alert('The Post Office Credit Card is only available to UK residents')
        return
      } 
      this.finding = true;
      this.invalidadd = false;
      this.invalidsame = false;
      var urlspace = "";
      if (getById("houseName").value.trim() !== "") {
        urlspace = "%20";
      }
      var urlfull = this.experurl + "search?country=GBR&take=100&query=" + getById("houseName").value.trim() + urlspace + getById("postCodeAuto").value.replace(" ", "%20") + "&auth-token=" + this.experkey;
      var xhttp = new XMLHttpRequest();
      xhttp.open("GET", urlfull, true);
      xhttp.send(null);
      var parentapp = this;
      xhttp.onreadystatechange = function() {
        if (this.readyState == 4 && this.status == 200) {
          var experes = JSON.parse(this.responseText).results;

          if (!experes || experes.length == 0) {
            alert("No address found, please enter your address manually");

            parentapp.manual = true;
            parentapp.addready = true;
            return;
          }

          parentapp.selectopts = [];
          for (var i = 0; i < experes.length; i++) {
            parentapp.selectopts.push([
              experes[i].format,
              experes[i].suggestion
            ]);
          }
          var housenameis = "Choose below";
          if (getById("houseName").value.trim() !== "") {
            housenameis = getById("houseName").value.trim();
          }
          parentapp.namePostcode = [housenameis, getById("postCodeAuto").value.trim()];
          parentapp.card = true;
          parentapp.chooseopt = true;
        } else if (this.readyState == 4) {
          alert(
            "Unable to find address due to a technical issue, " +
              "please enter your address manually"
          );

          parentapp.manual = true;
          parentapp.addready = true;
        }
      };
    },
    formatAdd: function(a) {
      var xhttp = new XMLHttpRequest();
      xhttp.open("GET", a + "&auth-token=" + this.experkey, true);
      xhttp.send(null);
      var parentapp = this;
      xhttp.onreadystatechange = function() {
        if (this.readyState == 4 && this.status == 200) {
          var addcomps = JSON.stringify(
            JSON.parse(this.responseText).components
          ).replace(/[{}[\]]/g, "");
          addcomps = JSON.parse("{" + addcomps + "}");
          var firstline = "";

          if (addcomps.streetNumber1) {
            firstline = addcomps.streetNumber1;
          } else {
            firstline = addcomps.building1;
          }

          // set current address as per api spec
          parentapp.selectedAddress = parentapp.transformAddressToApiFormat(
            addcomps
          );

          var getSafeProperty = (obj, prop) => obj && obj[prop] ? obj[prop] : '';

          var addressObj = {
              subBuilding1: getSafeProperty(parentapp.selectedAddress, "flatNumber"),
              building1: getSafeProperty(parentapp.selectedAddress, "houseName"),
              streetNumber1: getSafeProperty(parentapp.selectedAddress, "houseNumber"),
              street1: getSafeProperty(parentapp.selectedAddress, "streetName"),
              locality1: getSafeProperty(parentapp.selectedAddress, "localityName"),
              townName: parentapp.toSentenceCase(getSafeProperty(parentapp.selectedAddress, "townName")),
              localityName: getSafeProperty(parentapp.selectedAddress, "localityName"),
              countyName: getSafeProperty(parentapp.selectedAddress, "countyName"),
              postalCode1: getSafeProperty(addcomps, "postalCode1")
          };

          parentapp.savedAddress = addressObj;
          parentapp.updateAddressArrayInParent(addressObj);

          parentapp.formatted.push(
            firstline,
            addcomps.street1,
            addcomps.locality2,
            addcomps.locality1,
            "",
            addcomps.postalCode1.replace(" ", "")
          );
        }
      };
      focusAddress(getById(this.$props.text + "AddressHead"), 0);
    },
    /**
     * Format address object into format
     * expected by API upon POST
     */
    transformAddressToApiFormat: function(addressObj) {
      var tempObj = {};

      if (addressObj.subBuilding1) {
        tempObj.flatNumber = addressObj.subBuilding1;
      }

      if (addressObj.building1) {
        tempObj.houseName = addressObj.building1;
      }

      if (addressObj.streetNumber1) {
        tempObj.houseNumber = addressObj.streetNumber1;
      }

      if (addressObj.locality1) {
        tempObj.localityName = addressObj.locality1;
      }

      if (addressObj.locality2) {
        tempObj.localityName = addressObj.locality2;
      }

      if (addressObj.locality1 && !addressObj.townName) {
        tempObj.townName = addressObj.locality1;
        if(!addressObj.locality2) {
          delete tempObj.localityName;
        }
      } else if (addressObj.townName) {
        tempObj.townName = addressObj.townName;
      }

      if (addressObj.countyName) {
        tempObj.countyName = addressObj.countyName;
      }

      if (addressObj.street1) {
        tempObj.streetName = addressObj.street1;
      }

      tempObj.postCode = addressObj.postalCode1.replace(" ", "");

      return tempObj;
    },
    validateAddress: function(addressObject, formatted, manual, timeElementNames) {
      var addressFieldValidations;
      this.timeAndAddressAdded = false;

      var erraddress = false;
      var errsame = false;

      //remove previous address if not required
      if(this.text == 'current' && this.manual && this.addednow && parseInt(getById(this.time[0][0]).getAttribute("data-selection")) >= parseInt(process.env.VUE_APP_ADDRESS_MIN_YEARS)) {
        this.removePrev();
      }

      if (manual || this.editing) {
        if(getById("flatNumber") && getById("houseNumber") && getById("houseNameManual")) {
          if (!getById("flatNumber").value.trim() && !getById("houseNumber").value.trim() && !getById("houseNameManual").value.trim()) {
            this.$set(this.errors, "noneOfThree", "Please enter one of the following: flat number, house name or house number");
            erraddress = true;
          } else {
            this.$delete(this.errors, "noneOfThree");
            erraddress = false;
          }
        }
        addressFieldValidations = this.addressFieldValidations;
      } else {
        addressFieldValidations = {
          houseName: { min: 1, max: 32, optional: false }
        };
      }

      // reset error state for previous address months & years selection
      this.addressLengthBothEmpty = false;

      //the validation of the manual address fields
      for (var i = 0; i < addressObject.length; i++) {
        if (addressObject[i][1] in addressFieldValidations && manual) {

          var validationItem = addressFieldValidations[addressObject[i][1]];
          var validationElement = getById(addressObject[i][1]);
          var fieldLength = validationElement.value.trim().length;

          /*if (fieldLength == 0 && validationItem.optional) {
            continue;
          }*/

          if(fieldLength == 0 && !validationItem.optional) {
            this.$set(this.errors, addressObject[i][1], "Please enter a " + validationItem.name);
            this.$set(this.touchedFields, addressObject[i][1], true);
            erraddress = true;
          }

          if (fieldLength > validationItem.max) {
            this.$set(this.errors, addressObject[i][1], "Please enter a " + validationItem.name + " of " + validationItem.max + " characters or less" );
            erraddress = true;
          } else if (fieldLength != 0 && fieldLength < validationItem.min) {
            this.$set(this.errors, addressObject[i][1], "Please enter a " + validationItem.name + " of " + validationItem.min + " or more characters" );
            this.$set(this.touchedFields, addressObject[i][1], true);
            erraddress = true;
          }
        }

        //house name (for lookup), postcodeAuto (for lookup) and postCode (manual)
        if (addressObject[i][2] == true && getById(addressObject[i][1]) != null) {
          var value = getById(addressObject[i][1]).value.trim();
          var isValid = true;

          if (addressObject[i][1] == "houseName") {
            isValid = /^[0-9A-Z- '/]*$/i.test(value);
            if(!isValid) {
              this.$set(this.errors, "houseName", "Please enter a valid house name or number");
              this.$set(this.touchedFields, addressObject[i][1], true);
              erraddress = true;
            }
          } else {
            isValid = /^[A-Z]{1,2}[0-9][0-9A-Z]?[ ]?[0-9][A-Z]{2}$/i.test(value);

            if (manual && addressObject[i][1] === 'postCode') {
              if (!isValid) {
                this.$set(this.errors, "postCode", "Please enter a valid postcode");
                this.$set(this.touchedFields, addressObject[i][1], true);
                erraddress = true;
              }
              if(value == "") {
                this.$set(this.errors, "postCode", "Please enter a postcode");
                this.$set(this.touchedFields, addressObject[i][1], true);
                erraddress = true;
              }
            } else if (!manual && addressObject[i][1] === 'postCodeAuto') {
              if(!isValid) {
                this.$set(this.errors, "postCodeAuto", "Please enter a valid postcode");
                this.$set(this.touchedFields, addressObject[i][1], true);
                erraddress = true;
              }
              if(value == "") {
                this.$set(this.errors, "postCodeAuto", "Please enter a postcode");
                this.$set(this.touchedFields, addressObject[i][1], true);
                erraddress = true;
              }
            }
          }
        }
      }

      if(this.text == 'previous') {
        var currentNameAndPostcode = JSON.parse(getById("currentAddTop").innerHTML);
        var currentHouseNameOrNumber = currentNameAndPostcode[0];
        var currentPostcode = currentNameAndPostcode[1];
        var savedNameAndPostcode = "";

        if(!this.card) {
          if (this.editing || this.manual) {
            if (!getById("flatNumber").value.trim().length == 0) {
              savedNameAndPostcode = [
                getById("flatNumber").value.trim(),
                getById("postCode").value.trim()
              ];
            } else if (!getById("houseNameManual").value.trim().length == 0) {
              savedNameAndPostcode = [
                getById("houseNameManual").value.trim(),
                getById("postCode").value.trim()
              ];
            } else {
              savedNameAndPostcode = [
                getById("houseNumber").value.trim(),
                getById("postCode").value.trim()
              ];
            }

            if(savedNameAndPostcode[0].toUpperCase().replace(" ", "") === currentHouseNameOrNumber.toUpperCase().replace(" ", "") &&
            savedNameAndPostcode[1].toUpperCase().replace(" ", "") === currentPostcode.toUpperCase().replace(" ", "")) {
              errsame = true;
            }
          } else {
            if (currentHouseNameOrNumber.toUpperCase().replace(" ", "") == getById('houseName').value.toUpperCase().replace(" ", "") &&
              currentPostcode.toUpperCase().replace(" ", "") == getById('postCodeAuto').value.toUpperCase().replace(" ", "") ) {
                errsame = true;
              }
          }
        }
      }

      this.showAddressDurationError = false;

      if (timeElementNames) {
        if(this.showMonthsDropdown) {
          for (var i = 0; i < timeElementNames.length; i++) {
            var timeItem = getById(timeElementNames[i][0]);
            var timeValue = timeItem.getAttribute("data-selection");
            if (timeValue == null || !timeValue) {
              this.$set(this.errors, "timem", "Please select number of months at this address");
              this.showAddressDurationError = true;
            }
          }
        } else {
          var timeItem = getById(timeElementNames[0][0]);
          if(timeItem) {
            var timeValue = timeItem.getAttribute("data-selection");
            if (timeValue == null || !timeValue) {
              this.$set(this.errors, "timey", "Please select number of years at this address");
              this.showAddressDurationError = true;
            }
          }
        }
      }

      if (this.showAddressDurationError) {
        if(this.errors.hasOwnProperty('timey')) {
          var timey = getById('timey');
          var timeyError = timey.parentElement.previousElementSibling;
          this.$nextTick(() => {
            focusAddress(timeyError, 0);
          })
        }
        if(this.errors.hasOwnProperty('timem')) {
          var timem = getById('timem');
          var timemError = timem.parentElement.previousElementSibling;
          this.$nextTick(() => {
            focusAddress(timemError, 0);
          })
        }
        return;
      }

      if (erraddress) {
        this.invalidadd = true;
        this.$set(this.errors, "errorSummary", " ");
      } else if (errsame) {
        this.invalidsame = true;
        this.$nextTick(() => {
          if(getById('errorSame')) {
            focusAddress(getById('errorSame'), 0);
          }
        })
      } else {
        this.errors = {};
        return true;
      }
      if(document.querySelector('.editing-address-entry') || document.querySelector('.manual-address-entry')) {
        if (document.querySelector('.editing-address-entry')) {
          var thisAddressArea = document.querySelector('.editing-address-entry')
        }
        if (document.querySelector('.manual-address-entry')) {
          var thisAddressArea = document.querySelector('.manual-address-entry')
        }
        this.$nextTick(() => {
          var firstError = thisAddressArea.querySelector('.js-form-error:not(.hidden)');
          var allErrors = thisAddressArea.querySelectorAll('.js-form-error:not(.hidden)');

          //ensures that if the error is related to min/max character length then
          //this error should get the focus
          //otherwise the screenreader user will read out the larger generic error
          //which makes no mention of character length
          allErrors.forEach((error) => {
            if(error.innerHTML.includes("characters or less") || error.innerHTML.includes('or more characters')) {
              firstError = error;
            }
          })

          focusAddress(firstError, 0);
          firstError.scrollIntoView({ behavior: 'instant', block: 'center' });
        })
      } else {
        focusAddress(getById(this.$props.text + "AddressHead", 0));
      }
    },
    addAddress: function(a, time, manual, d, e) {

      if (manual) {
        this.chosenopt = "";
        if (!getById("flatNumber").value.trim().length == 0) {
          this.namePostcode = [
            getById("flatNumber").value.trim(),
            getById("postCode").value.trim()
          ];
        } else if (!getById("houseNameManual").value.trim().length == 0) {
          this.namePostcode = [
            getById("houseNameManual").value.trim(),
            getById("postCode").value.trim()
          ];
        } else {
          this.namePostcode = [
            getById("houseNumber").value.trim(),
            getById("postCode").value.trim()
          ];
        }

        var rawPostcode = getById("postCode").value.toUpperCase();

        var formattedPostCode = getById("postCode")
          .value.toUpperCase()
          .replace(" ", "");

        var addressObj = {
          subBuilding1: getById("flatNumber").value.trim(),
          building1: getById("houseNameManual").value.trim(),
          streetNumber1: getById("houseNumber").value.trim(),
          street1: getById("streetName").value.trim(),
          locality1: getById("localityName").value.trim(),
          townName: getById("townName").value.trim(),
          localityName: getById("localityName").value.trim(),
          countyName: getById("countyName").value.trim(),
          postalCode1: formattedPostCode
        };

        this.savedAddress = {
          ...addressObj,
          postalCode1: rawPostcode
        };

        this.updateAddressArrayInParent(this.savedAddress);
        this.selectedAddress = this.transformAddressToApiFormat(addressObj);

        if (addressObj["subBuilding1"] && addressObj["streetNumber1"] && addressObj["building1"]) {
          this.chosenopt = 
            addressObj["subBuilding1"] + ", " +
            addressObj["streetNumber1"] + " " + addressObj["building1"] + ", " +
            (addressObj["street1"] ? addressObj["street1"] + ", " : '') +
            (addressObj["localityName"] ? addressObj["localityName"] + ", " : '') +
            (addressObj["townName"] ? addressObj["townName"] + ", " : '') +
            (addressObj["countyName"] ? addressObj["countyName"] + ", " : '') +
            (rawPostcode ? rawPostcode : '');
        }

        if (addressObj["subBuilding1"] && addressObj["streetNumber1"] && !addressObj["building1"]) {
          this.chosenopt = 
            addressObj["subBuilding1"] + ", " +
            addressObj["streetNumber1"] + " " + (addressObj["street1"] ? addressObj["street1"] + ", " : '') +
            (addressObj["localityName"] ? addressObj["localityName"] + ", " : '') +
            (addressObj["townName"] ? addressObj["townName"] + ", " : '') +
            (addressObj["countyName"] ? addressObj["countyName"] + ", " : '') +
            (rawPostcode ? rawPostcode : '');
        }

        if (addressObj["subBuilding1"] && !addressObj["streetNumber1"] && addressObj["building1"]) {
          this.chosenopt = 
            addressObj["subBuilding1"] + " " + addressObj["building1"] + ", " +
            (addressObj["street1"] ? addressObj["street1"] + ", " : '') +
            (addressObj["localityName"] ? addressObj["localityName"] + ", " : '') +
            (addressObj["townName"] ? addressObj["townName"] + ", " : '') +
            (addressObj["countyName"] ? addressObj["countyName"] + ", " : '') +
            (rawPostcode ? rawPostcode : '');
        }

        if (!addressObj["subBuilding1"] && addressObj["streetNumber1"] && addressObj["building1"]) {
          this.chosenopt = 
            addressObj["streetNumber1"] + " " + addressObj["building1"] + ", " +
            (addressObj["street1"] ? addressObj["street1"] + ", " : '') +
            (addressObj["localityName"] ? addressObj["localityName"] + ", " : '') +
            (addressObj["townName"] ? addressObj["townName"] + ", " : '') +
            (addressObj["countyName"] ? addressObj["countyName"] + ", " : '') +
            (rawPostcode ? rawPostcode : '');
        }

        if (addressObj["subBuilding1"] && !addressObj["streetNumber1"] && !addressObj["building1"]) {
          this.chosenopt = 
            addressObj["subBuilding1"] + ", " +
            (addressObj["street1"] ? addressObj["street1"] + ", " : '') +
            (addressObj["localityName"] ? addressObj["localityName"] + ", " : '') +
            (addressObj["townName"] ? addressObj["townName"] + ", " : '') +
            (addressObj["countyName"] ? addressObj["countyName"] + ", " : '') +
            (rawPostcode ? rawPostcode : '');
        }

        if (!addressObj["subBuilding1"] && addressObj["streetNumber1"] && !addressObj["building1"]) {
          this.chosenopt = 
            addressObj["streetNumber1"] + " " + (addressObj["street1"] ? addressObj["street1"] + ", " : '') +
            (addressObj["localityName"] ? addressObj["localityName"] + ", " : '') +
            (addressObj["townName"] ? addressObj["townName"] + ", " : '') +
            (addressObj["countyName"] ? addressObj["countyName"] + ", " : '') +
            (rawPostcode ? rawPostcode : '');
        }

        if (!addressObj["subBuilding1"] && !addressObj["streetNumber1"] && addressObj["building1"]) {
          this.chosenopt = 
            addressObj["building1"] + ", " +
            (addressObj["street1"] ? addressObj["street1"] + ", " : '') +
            (addressObj["localityName"] ? addressObj["localityName"] + ", " : '') +
            (addressObj["townName"] ? addressObj["townName"] + ", " : '') +
            (addressObj["countyName"] ? addressObj["countyName"] + ", " : '') +
            (rawPostcode ? rawPostcode : '');
        }

        if (!addressObj["subBuilding1"] && !addressObj["streetNumber1"] && !addressObj["building1"]) {
          this.chosenopt = 
            (addressObj["street1"] ? addressObj["street1"] + ", " : '') +
            (addressObj["localityName"] ? addressObj["localityName"] + ", " : '') +
            (addressObj["townName"] ? addressObj["townName"] + ", " : '') +
            (addressObj["countyName"] ? addressObj["countyName"] + ", " : '') +
            (rawPostcode ? rawPostcode : '');
        }

        if (addressObj["subBuilding1"] && addressObj["streetNumber1"] && addressObj["building1"]) {
          this.chosenopt = 
            addressObj["subBuilding1"] + ", " +
            addressObj["streetNumber1"] + " " + addressObj["building1"] + ", " +
            (addressObj["street1"] ? addressObj["street1"] + ", " : '') +
            (addressObj["localityName"] ? addressObj["localityName"] + ", " : '') +
            (addressObj["townName"] ? addressObj["townName"] + ", " : '') +
            (addressObj["countyName"] ? addressObj["countyName"] + ", " : '') +
            (rawPostcode ? rawPostcode : '');
        }
      }

      if(this.showMonthsDropdown) { //if months is being saved then save years and months to the times array
        for (var i = 0; i < time.length; i++) {
          this.times[i] = getById(time[i][0]).getAttribute("data-selection");
        }
      } else { //otherwise only add years to the times array and only if 'time' is true ('time' is passed as false when 'Add this address' is clicked for manual address entry as this scenario doesn't contain the years/months dropdown)
        if(time) {
          this.times[0] = getById(time[0][0]).getAttribute("data-selection");
        }
      }

      if(this.showMonthsDropdown) {
        createAddress(this.selectedAddress, time, e); //pass years and months into createAddress
      } else if (!this.showMonthsDropdown && time) { 
        createAddress(this.selectedAddress, [time[0]], e) //pass just years into createAddress for non-manual address entry
      } else {
        createAddress(this.selectedAddress, time, e); //otherwise just pass empty time object (manual address entry)
      }

      this.card = true;

      if(time) {
        if (parseInt(getById(time[0][0]).getAttribute("data-selection")) < parseInt(process.env.VUE_APP_ADDRESS_MIN_YEARS)) {
          this.$emit("showprev");
        } else {
          this.$emit("hideprev");
        }
      }

      getById(e + "AddressHead").querySelector('.js-address-error').classList.add('hidden');
      focusAddress(getById(this.$props.text + "AddressHead"), 1);
      getById(this.$props.text + "AddressHead").scrollIntoView({behavior: 'instant'});

      if(this.times[0] != null) {
        this.timeAndAddressAdded = true;
        this.addDateMovedIn = false;
      } else {
        this.timeAndAddressAdded = false;
      }
    },
    updateAddressArrayInParent: function(addressObj) {

      //for saving to the address array in parent
      var addressObjForParent = {
        flatNumber: addressObj.subBuilding1,
        houseNameManual: addressObj.building1,
        houseNumber: addressObj.streetNumber1,
        streetName: addressObj.street1,
        localityName: addressObj.locality1,
        townName: addressObj.townName,
        countyName: addressObj.countyName,
        postCode: addressObj.postalCode1
      };

      //update the address array in the parent so values can be passed as prop to input-group
      //this means the input fields have the stored address values when we click on 'edit'
      this.$emit('update-address', addressObjForParent);
    },
    headFocusCustom(id, scroll) {
      this.$nextTick(() => {
        focusAddress(getById(id), 0);
        if(scroll) {
          getById(id).scrollIntoView(true);
        }
      })
    },
    notExact(a) {
      if (
        getById("currentAddFull") &&
        a == getById("currentAddFull").innerHTML.replaceAll("<br>", "")
      ) {
        alert("Previous address can't be the same as your current address");
        return false;
      } else {
        return true;
      }
    },
    removePrev: function() {
      prevaddress = "";
      this.$emit("hideprev");
    },
    reset: function() {
      focusAddress(getById(this.$props.text + "AddressHead"), 0);
      Object.assign(this.$data, this.$options.data());

      var addressHeadElement = getById(this.$props.text + "AddressHead");

      if(addressHeadElement) {
        addressHeadElement.scrollIntoView({ behavior: 'instant' });
      }

      if(this.text == 'previous') {
        this.$emit('reset-address-manual', 'previous');
        prevaddress = "";
      } else {
        this.$emit('reset-address-manual', 'current');
        curraddress = "";
        this.$emit("hideprev");
      }
    },
    edit: function() {
      this.manual = true;
      this.editing = true;
      this.addready = true;

      // Store initial values
      this.initialTimes = this.times ? [...this.times] : [null, null];

      if(this.text == 'previous') {
        this.$emit('update:editingPrevious', true);
      } else {
        this.$emit('update:editingCurrent', true);
      }

      if(getById('btnCancel')) {
        getById('btnCancel').click();
      }

      this.$nextTick(() => {
        var addressInputs = document.querySelectorAll('.address-lookup.' + this.text + ' .inputgroup input');
        this.headFocusCustom(this.text + 'AddressHead', true);

        for (var i = 0; i < addressInputs.length; i++) {
          if(addressInputs[i].value != "") {
            addressInputs[i].classList.add('complete');
          }
        }
      });
    },
    cancel: function() {
      this.editing = false;
      this.manual = false;
      this.skipWatcher = true;

      this.times = [...this.initialTimes];

      if (!this.timeAndAddressAdded) {
        //this.times[0] = null;
        //this.times[1] = null;
        this.showMonthsDropdown = false;

        // Find all numb-choose components and reset them
        /*this.$children.forEach(child => {
            if (child.$options.name === 'numbChoose') {
                child.reset();
            }
        });*/
        this.skipWatcher = false;
      }
      this.$delete(this.errors, "timey");
      this.$delete(this.errors, "timem");
      this.headFocusCustom(this.$props.text + "AddressHead", true);
    },
    dateMovedIn: function() {
      var currentDate = new Date();
      var monthInput = getById(this.text + 'MovedInMonth');
      var yearInput = getById(this.text + 'MovedInYear');
      var month = monthInput.value.trim();
      var year = yearInput.value.trim();
      var movedInDate = new Date(year, month - 1);
      var valid = true;

      if (!month || isNaN(month) || month < 1 || month > 12) {
        valid = false;
      }

      if (!year || isNaN(year) || year < currentDate.getFullYear() - 120) {
        valid = false;
      }

      if(movedInDate.getTime() > currentDate.getTime()) {
        valid = false;
      }

      if (!valid) {
        this.$set(this.errors, "dateMovedIn", "Please enter a valid date");
        this.$nextTick(() => {
          focusAddress(document.querySelector('#dateMovedIn .js-form-error'), 0);
        })
        return;
      }

      // Calculate the difference in years and months
      var years = currentDate.getFullYear() - movedInDate.getFullYear();
      var months = currentDate.getMonth() - movedInDate.getMonth();

      // Adjust for partial years and months
      if (months < 0) {
        years--;
        months += 12;
      }

      // Adjust for partial months
      if (currentDate.getDate() < movedInDate.getDate()) {
        months--;
        if (months < 0) {
          years--;
          months += 12;
        }
      }

      if(years > 75) {
        this.$set(this.errors, "dateMovedIn", "Please enter a valid date");
        return;
      }

      if (valid) {
        this.$set(this.times, 0, years);
        this.$set(this.times, 1, months);
        this.showMonthsDropdown = true;
        this.addDateMovedIn = false;
        this.$delete(this.errors, "timem");
        this.$delete(this.errors, "timey");
      }
    },
    resetMonths() {
      this.times[1] = null; // Set months to 1 when years are 0 in the previous address
    }
  },
  watch: {
    times: {
      deep: true,
      handler(timesArray) {

        this.$nextTick(async () => {
          if(this.skipWatcher) {
            return;
          } 
          var yearsAtAddress = timesArray[0];
          var monthsAtAddress = timesArray[1];

          if (this.showMonthsDropdown) {
            var isTimeAtAddressEntryComplete = (yearsAtAddress !== null && monthsAtAddress !== null);
          } else {
            var isTimeAtAddressEntryComplete = (yearsAtAddress !== null);
          }

          if (isTimeAtAddressEntryComplete && parseInt(yearsAtAddress) < parseInt(process.env.VUE_APP_ADDRESS_MIN_YEARS) && this.$props.text !== 'previous' && JSON.stringify(timesArray) !== JSON.stringify(this.previousTimes)) {
            this.showAddressDurationError = false;
            if (!this.editing) {
              if (this.validateAddress(this.objManual, this.formatted, this.manual, this.time)) {
                this.addAddress(this.objManual, this.time, this.manual, this.chosenopt, this.text);
                this.addready = true;
                this.addednow = true;
                this.manual = false;
                this.showAddressDurationError = false;
                this.addDateMovedIn = false;
                this.$emit("showprev");
              }
            }
          }
          
          if (isTimeAtAddressEntryComplete && JSON.stringify(timesArray) !== JSON.stringify(this.previousTimes) && !this.editing) {
            if (this.validateAddress(this.objManual, this.formatted, this.manual, this.time)) {
                this.addAddress(this.objManual, this.time, this.manual, this.chosenopt, this.text);
                this.addready = true;
                this.addednow = true;
                this.manual = false;
                this.addDateMovedIn = false;
                this.showAddressDurationError = false;
              }
          }
        })
      }
    },
    editing(editing) {
      if(this.text == 'current') {
        this.$emit('update:editingCurrent', true)
      } else {
        this.$emit('update:editingPrevious', true)
      }
      if (!editing) {
        if(this.text == 'current') {
          this.$emit('update:editingCurrent', false);
        } else {
          this.$emit('update:editingPrevious', false);
        }
      }
    },
    chooseopt(newVal) {
      if (newVal && !this.manual && !this.editing) {
        this.$nextTick(() => {
          this.headFocusCustom('selectAddressList');
          getById('selectAddressList').scrollIntoView({ behavior: 'instant', block: 'center' });
        });
      }
    },
    chosenopt(newVal) {
      if(newVal) {
        this.$nextTick(() => {
          this.headFocusCustom(this.text + 'AddressHead', true);
        });
      }
    }
  }
}
</script>

<style scoped>

.h3 {
  font-size: 1.3125rem;
  line-height: 1.96875rem;
  margin-bottom: 0.5rem;
}

.address-head {
  scroll-margin-top: 1.785rem;
}

.address-head + .note {
  margin-top: 0;
}

.period-at-address-error {
  margin-top: 0px;
  margin-bottom: 10px !important;
}

</style>

<style scoped src="@/v1/assets/css/address.css"></style>